export default class ImageHoverReveal {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        window.addEventListener('DOMContentLoaded', () => {

            const listItems = document.querySelectorAll('.js-image-hover');

            listItems.forEach((item) => {
                item.addEventListener('mouseenter', () => {
                    item.children[1].style.transitionProperty = 'opacity';
                    item.children[1].style.transitionDuration = '50ms';
                    item.children[1].style.transitionTimingFunction = 'cubic-bezier(.4,0,.2,1)';
                    item.children[1].style.opacity = 1;
                    item.children[0].style.zIndex = 10;
                });

                item.addEventListener('mouseleave', () => {
                    item.children[1].style.transitionProperty = 'opacity';
                    item.children[1].style.transitionDuration = '50ms';
                    item.children[1].style.transitionTimingFunction = 'cubic-bezier(.4,0,.2,1)';
                    item.children[1].style.opacity = 0;
                    item.children[0].style.zIndex = 1;
                });
            });

        });

    }

};

new ImageHoverReveal();